<template>
  <div class="modal-mask">
    <div class="modal-content-container">
      <div class="new-product__main-container">
        <div class="new-product__header-container">
          <span class="new-product__header-title">Novo Produto</span>
          <span @click="closeDialog" class="material-icons new-product__closebtn-icon">
            cancel
          </span>
        </div>
        <div class="standard-buttons__wrapper">
          <StandardButton
            class="standard-btn"
            :action="validaFormularioCadastro"
            :iconName="'save'"
            :text="'Salvar'"
          />
          <StandardButton
            class="standard-btn"
            :action="closeDialog"
            :iconName="'arrow_back'"
            :text="'Voltar'"
          />
        </div>
        <cc-loader v-if="loading" style="margin-top: 20vh" />
        <div v-else>
          <div class="new-product__actions-wrapper">
            <div class="new-product__input-wrapper">
              <span class="new-product__input-title"
                >Descrição <span style="color: red !important">*</span></span
              >
              <input
                v-model="produtoModal"
                type="text"
                placeholder="Digite a Descrição do Produto"
                class="new-product__input"
                :class="{ erroInput: errorProdutoModal }"
                @focus="errorProdutoModal = false"
              />
            </div>
            <div class="new-product__input-wrapper">
              <span class="new-product__input-title"
                >Categorias <span style="color: red !important">*</span></span
              >
              <cc-select-v2
                class="new-product-select-width"
                :class="{ erroInput: errorCategoriaModal }"
                @focus="errorCategoriaModal = false"
                :tracker="'cat_id'"
                :text="'cat_descricao'"
                :options="categories"
                v-model="categoriaModal"
              ></cc-select-v2>
            </div>
          </div>
          <div class="new-product__actions-wrapper">
            <div class="new-product__input-wrapper">
              <span class="new-product__input-title">Código Interno</span>
              <input
                v-model="codigoModal"
                type="text"
                placeholder="Código Interno"
                class="new-product__input"
              />
            </div>
            <div class="new-product__input-wrapper">
              <span class="new-product__input-title"
                >Código<span style="color: red !important">*</span></span
              >
              <input
                :disabled="disabledInputs"
                v-model="codEanModal"
                type="number"
                :placeholder="'Digite o Código '"
                class="new-product__input"
                :class="{ erroInput: errorCodEanModal }"
                @focus="errorCodEanModal = false"
              />
            </div>
          </div>
          <div class="new-product__actions-wrapper">
            <div class="new-product__input-wrapper mobile-margin">
              <span class="new-product__input-title"
                >Unidade <span style="color: red !important">*</span></span
              >
              <cc-select-v2
                v-if="!isGenerico"
                class="new-product-select-width"
                :class="{ erroInput: errorEmbalagemModal }"
                @focus="errorEmbalagemModal = false"
                :tracker="'value'"
                :text="'name'"
                v-model="wrap"
                :options="wraps"
              ></cc-select-v2>
              <div class="new-product-generic-input new-product-select-width" v-else>
                <input
                  v-model="wrap"
                  type="text"
                  style="width: 90% !important"
                  placeholder="Digite a unidade"
                  class="new-product__input"
                  :class="{ erroInput: errorEmbalagemModal }"
                  @focus="errorEmbalagemModal = false"
                />
              </div>
            </div>
            <div class="new-product__input-wrapper">
              <span class="new-product__input-title"
                >QTD Embalagem <span style="color: red !important">*</span></span
              >
              <input
                :disabled="
                  wrap && (wrap.value == 'UN' || wrap.value == 'DZ' || isGenerico)
                "
                @focus="errorQtdEmbalagemModal = false"
                :class="{ erroInput: errorQtdEmbalagemModal }"
                v-model="qtdEmbalagemModal"
                type="text"
                placeholder="Selecione uma Quantidade Embalagem"
                class="new-product__input"
              />
            </div>
          </div>
          <div class="new-product__actions-wrapper">
            <div class="new-product__input-wrapper">
              <span class="new-product__input-title">Fornecedor Exclusivo</span>
              <cc-select-v2
                class="new-product-select-width"
                v-model="selectedProvider"
                :searchable="true"
                :tracker="'value'"
                :text="'text'"
                :options="providers"
              ></cc-select-v2>
            </div>
            <div class="new-product__input-wrapper">
              <span class="new-product__input-title">Vendedor</span>
              <cc-select-v2
                class="new-product-select-width"
                :class="{ erroInput: selectedBuyerError }"
                v-model="selectedBuyer"
                :tracker="'value'"
                :text="'text'"
                :options="buyers"
              ></cc-select-v2>
            </div>
          </div>
          <div style="display: flex">
            <div class="new-product__generic-option-wrapper">
              <div class="new-product__generic-checkbox-wrapper">
                <cc-checkbox
                  :checked="isGenerico"
                  @change="(evt) => toggle_generic(evt.target.checked)"
                />
              </div>
              <div class="new-product__generic-title-wrapper">
                <span class="new-product__generic-title"> Produto Genérico? </span>
              </div>
            </div>
            <div class="new-product__generic-option-wrapper">
              <div class="new-product__generic-checkbox-wrapper">
                <cc-checkbox
                  :checked="product.pro_pedido_direto"
                  @change="(evt) => (product.pro_pedido_direto = evt.target.checked)"
                />
              </div>
              <div class="new-product__generic-title-wrapper">
                <span class="new-product__generic-title"> Produto Pedido direto? </span>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 py-3">
              <toggle-button
                v-model="statusModal"
                :color="'var(--primary-color)'"
                :height="30"
                :labels="{ checked: 'Ativo', unchecked: 'Inativo' }"
                :width="75"
              />
            </div>
          </div>

          <div class="new-product__actions-wrapper-centered">
            <div class="new-product__input-wrapper" v-if="to_request">
              <span class="new-product__input-title"
                >Quantidade <span style="color: red !important">*</span></span
              >
              <input
                v-model.number="produtoQuantidadeCotacaoModal"
                type="number"
                placeholder="Quantidade"
                class="new-product__input"
                :class="{ erroInput: errorQtdEmbalagemModal }"
                @focus="errorQtdEmbalagemModal = false"
                min="1"
                @change="
                  produtoQuantidadeCotacaoModal = Math.max(
                    1,
                    produtoQuantidadeCotacaoModal || 1
                  )
                "
              />
            </div>
          </div>
          <div v-if="serverMsg" class="col-md-12 col-lg-12">
            <h4 class="py-4 text-center text-danger">{{ serverMsg }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/constants/constants";
import ProductService from "@/services/ProductService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import QuotationService from "../../services/QuotationService";
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";
import SellersService from "@/services/v3/commons/sellers.service";
import ProviderService from "@/services/v3/provider.service";

export default {
  components: { StandardButton },
  props: {
    product: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && (value.pro_id || value.pro_ean);
      },
    },
    to_request: {
      type: Boolean,
      default: false,
    },
    closeDialog: {
      type: Function,
    },
  },
  data() {
    return {
      loading: true,
      wraps: [
        { name: "Atado", value: "AT" },
        { name: "Unidade", value: "UN" },
        { name: "Caixa", value: "CX" },
        { name: "Fardo", value: "FD" },
        { name: "Kilograma", value: "KG" },
        { name: "Duzia", value: "DZ" },
        { name: "Display", value: "DP" },
        { name: "Pacote", value: "PC" },
      ],
      wraps_generic: [
        { name: "Unidade", value: "UN" },
        { name: "Litro", value: "LT" },
        { name: "Kilograma", value: "KG" },
        { name: "Caixa", value: "CX" },
        { name: "Fardo", value: "FD" },
      ],
      errorProdutoModal: false,
      errorEmbalagemModal: false,
      errorQtdEmbalagemModal: false,
      errorCategoriaModal: false,
      errorCodEanModal: false,
      statusModal: true,
      wrap: "",
      codigoModal: "",
      produtoModal: "",
      qtdEmbalagemModal: 1,
      produtoQuantidadeCotacaoModal: 1,
      categoriaModal: "",
      codEanModal: "",
      serverMsg: "",
      isGenerico: false,
      stores: [],
      categories: [],
      providers: [],
      buyers: [],
      selectedBuyerError: false,
      selectedBuyer: null,
      selectedProvider: null,
      product_service: new ProductService(),
      psvc: new ProviderService(),
      service: new QuotationService(),
      sellers_svc: new SellersService(),
      errorCodEanModal: false,
      disabledInputs: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },

    validaFormularioCadastro() {
      this.errorProdutoModal = false;
      this.errorEmbalagemModal = false;
      this.errorQtdEmbalagemModal = false;
      this.errorCategoriaModal = false;
      this.errorCodEanModal = false;
      this.selectedBuyerError = false;

      let isValid = true;

      if (!this.produtoModal) {
        this.errorProdutoModal = true;
        isValid = false;
      }
      if (!this.wrap) {
        this.errorEmbalagemModal = true;
      }
      if (!this.qtdEmbalagemModal) {
        this.errorQtdEmbalagemModal = true;
      }
      if (!this.categoriaModal) {
        this.errorCategoriaModal = true;
      }
      if (!this.codEanModal) {
        this.errorCodEanModal = true;
      }
      if (this.selectedProvider && !this.selectedBuyer) {
        this.selectedBuyerError = true;
      }

      if (isValid) {
        this.loading = true;

        const data = {
          codInterno: this.codigoModal,
          generico: this.isGenerico ? 1 : 0,
          pro_pedido_direto: this.product.pro_pedido_direto ? 1 : 0,
          unidade_compra: this.isGenerico ? this.wrap : this.wrap?.value || "UN",
          descricao: this.produtoModal,
          embalagem: this.isGenerico
            ? "UN 1"
            : `${this.wrap?.value || "UN"} ${this.qtdEmbalagemModal || 1}`.trim(),
          categoria: this.categoriaModal?.cat_id || null,
          codEan: this.codEanModal,
          pro_status: this.statusModal ? 1 : 0,
          lojas_sugestao: this.stores.filter((s) => s.qtd_sugestao != null),
          vendedor_exclusivo: this.selectedBuyer?.value?.id || null,
          quantidade: Math.max(1, this.produtoQuantidadeCotacaoModal || 1),
        };

        const config = {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        };

        axios
          .post(`${CONSTANTS.API_URL}/inserirprodutonormalcliente`, data, config)
          .then((response) => {
            const productData = {
              pro_id: response.data.id,
              pro_ean: this.codEanModal,
              pro_descricao: this.produtoModal,
              new_amount: Math.max(1, this.produtoQuantidadeCotacaoModal || 1),
            };

            this.$emit("emit_product", productData);
            this.$swal.fire("Sucesso!", "Produto cadastrado com sucesso", "success");
            this.closeDialog();
          })
          .catch((error) => {
            console.error("Erro no cadastro:", error.response || error); // Debug
            this.serverMsg =
              error.response?.data?.mensagem ||
              error.response?.data?.message ||
              "Erro ao cadastrar produto";
            this.loading = false;
          });
      } else {
        this.serverMsg = "Preencha os campos obrigatórios corretamente";
      }
    },

    load_categories() {
      return this.service
        .getCategorias()
        .then((response) => response.data)
        .then((data) => {
          this.categories = data.categorias;
        });
    },

    cadastroProduto() {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const quantidade = Math.max(1, this.produtoQuantidadeCotacaoModal || 1);

      const data = {
        codInterno: this.codigoModal,
        generico: this.isGenerico ? 1 : 0,
        pro_pedido_direto: this.product.pro_pedido_direto ? 1 : 0,
        unidade_compra: this.isGenerico ? this.wrap : this.wrap?.value || "UN",
        descricao: this.produtoModal,
        embalagem: this.isGenerico
          ? "UN 1"
          : `${this.wrap?.value || "UN"} ${this.qtdEmbalagemModal || 1}`.trim(),
        categoria: this.categoriaModal?.cat_id || null,
        codEan: this.codEanModal,
        pro_status: this.statusModal ? 1 : 0,
        lojas_sugestao: this.stores.filter((s) => s.qtd_sugestao != null),
        vendedor_exclusivo: this.selectedBuyer?.value?.id || null,
        quantidade: quantidade,
      };

      axios
        .post(`${CONSTANTS.API_URL}/inserirprodutonormalcliente`, data, config)
        .then((res) => {
          this.loading = false;
          if (this.to_request) {
            this.$emit("emit_product", {
              ...data,
              pro_id: res.data.id,
              new_amount: quantidade,
            });
          }
          this.$swal.fire("Sucesso!", "Produto cadastrado com sucesso.", "success");
          this.closeDialog();
        })
        .catch((err) => {
          this.loading = false;
          console.error("Erro detalhado:", err.response);
          this.serverMsg =
            err.response?.data?.mensagem ||
            err.response?.data?.message ||
            "Erro ao cadastrar produto. Verifique os dados e tente novamente.";

          if (err.response?.data?.errors) {
            const errors = err.response.data.errors;
            if (errors.descricao) this.errorProdutoModal = true;
            if (errors.embalagem) this.errorEmbalagemModal = true;
            if (errors.categoria) this.errorCategoriaModal = true;
            if (errors.codEan) this.errorCodEanModal = true;
            if (errors.quantidade) {
              this.errorQtdEmbalagemModal = true;
              this.produtoQuantidadeCotacaoModal = 1;
            }
          }
        });
    },

    getStoresProcutSuggestion() {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      let url = `${CONSTANTS.API_URL}/v2/clients/${localStorage.getItem(
        "cli_id"
      )}/store/product/`;
      return axios.get(url, config).then((data) => {
        this.stores = data.data.lojas;
        this.loading = false;
      });
    },

    getBuyers() {
      this.selectedBuyer = null;
      if (!this.selectedProvider?.value) {
        this.buyers = [{ text: "Nenhum", value: null }];
        return;
      }
      this.sellers_svc
        .load_sellers({ provider_id: this.selectedProvider.value.id })
        .then((resp) => {
          this.buyers = resp.data.map((element) => {
            return { text: element.name, value: element };
          });
        });
    },

    load_providers() {
      this.psvc.load_providers({ related: true, noPagination: true }).then((response) => {
        this.providers.push({ text: "Nenhum", value: null });
        const providersData = response.data.data || response.data;
        providersData.forEach((p) => {
          this.providers.push({ text: p.name, value: p });
        });
      });
    },

    toggle_generic(checked) {
      this.wrap = "";
      this.codigoModal = "";
      this.isGenerico = checked;
      this.qtdEmbalagemModal = 1;
      this.wraps_load = checked ? this.wraps_generic : this.wraps;
    },
  },

  watch: {
    "wrap.value": function (new_val) {
      if (new_val == "UN") {
        this.qtdEmbalagemModal = 1;
      } else if (new_val == "DZ") {
        this.qtdEmbalagemModal = 12;
      }
    },
    selectedProvider() {
      this.getBuyers();
    },
  },

  mounted() {
    this.codEanModal = this.product.pro_ean || "";
    this.load_providers();
    this.load_categories()
      .then(() => this.getStoresProcutSuggestion())
      .then(() => {
        this.loading = false;
      });
  },
};
</script>
<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  font-size: 1rem;
}
.new-product-table-mobile-header {
  display: none;
}
.modal-content-container {
  background-color: white;
  min-width: 50vw;
  border-radius: 12px;
}
.new-product__main-container {
  width: 80vw;
  height: 120vh;
}
.new-product__header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 10px 10px 0px 0px;
  background-color: var(--primary-color);
}
.new-product__header-title {
  color: #ffffff;
  font-weight: 500;
  font-size: 1.5rem;
}
.new-product-select-width {
  width: 35vw !important;
}
.new-product__closebtn-icon {
  color: #ffffff;
  font-size: 2em;
  cursor: pointer;
}
.standard-buttons__wrapper {
  display: flex;
  flex-direction: row-reverse;
  margin: 20px;
}
.standard-btn {
  margin-left: 20px;
}
.new-product__actions-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
  justify-content: space-between;
  margin: 0em 2em 1em 1.2em;
}
.new-product__actions-wrapper-centered {
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
  justify-content: center;
  margin: 0em 2em 1em 1.2em;
}
.new-product-generic-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.edit-generic-icon {
  cursor: pointer;
  color: gray;
}
.new-product__input-wrapper {
  display: flex;
  flex-direction: column;
}
.new-product__input-title {
  color: #898989;
  font-weight: 400;
  font-size: 1.7em;
  letter-spacing: 0.15px;
  margin-bottom: 0.3em;
}
.new-product__input {
  width: 35vw;
  height: 5.5vh;
  padding: 0px 10px;
  border: 1px solid #c2c2c3;
  border-radius: 5.23px;
  font-weight: 400;
  font-size: 1rem;
  color: #a1a1a1;
}
.new-product__input-icon {
  position: relative;
  font-size: 1.7em;
  left: -30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a1a1a1;
}
.new-product__generic-option-wrapper {
  display: flex;
  align-items: center;
  margin: 1em 2.1.2em;
}
.new-product__generic-checkbox-wrapper {
}
.new-product__generic-title-wrapper {
  margin-left: 0.5em;
}
.new-product__generic-title {
  font-weight: 300;
  font-size: 1rem;
  color: #605f5f;
}
.new-product__table-container {
  overflow-y: auto;
  margin: 2em 1.2em;
  max-height: 30vh;
}
.new-product__table-wrapper {
}
.new-product__table-thead {
}
.new-product__table-thead-tr {
  background-color: #fffefc;
  border: 0.5px solid #e5e5e5;
  color: #605f5f;
  font-size: 1rem;
  font-weight: 400;
}
.new-product__table-th {
  font-size: 1rem;
  font-weight: 600;
}
.erroInput {
  outline: 1px solid red;
  border-radius: 5px;
}
.new-product__table-tbody {
}
.new-product__table-tbody-tr {
}
.new-product__table-td {
  color: #605f5f;
  font-size: 1rem;
  font-weight: 300;
}
.ressuply-products__edit-amount-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ressuply-products__edit-amount-icon {
  color: #fff;
  background-color: var(--primary-color);
  border: 1.5px solid #e5e5e5;
  border-radius: 0px 5px 5px 0px;
  cursor: pointer;
  position: relative;
  left: -5px;
  padding: 1px;
}
.product-amount {
  border: 1.5px solid #e5e5e5;
  margin-top: 6.2px;
  outline: none;
}
.focused-input:focus {
  border: 1.5px solid var(--primary-color);
}
.focused-input:focus-visible + .ressuply-products__edit-amount-icon {
  background-color: var(--primary-color);
}
.seemore-button-containear {
  display: flex;
  justify-content: center;
  
}
.page-table-line-special {
  background: #f7f7f7;
}

@media only screen and (max-width: 800px) {
  .new-product__main-container {
    width: 100vw;
    height: 115vh;
  }
  .standard-btn {
    margin: 5px;
  }
  .standard-buttons__wrapper {
    flex-direction: column-reverse;
  }
  .new-product__actions-wrapper {
    margin: 0em;
    justify-content: space-around;
  }
  .new-product__table-container {
    margin: 0 10px;
  }
  .new-product__table-container {
    max-height: 20vh;
  }
  .modal-mask {
    font-size: 2vw;
  }
  .new-product__table-thead {
    display: none;
  }
  .new-product__table-tbody-tr {
    flex-direction: column;
    display: flex;
    margin-bottom: 3vh;
    font-size: 1rem;
  }
  .new-product__table-td {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .new-product-table-mobile-header {
    display: flex;
    font-size: 1.1em;
    font-weight: 700;
  }
  .new-product__input-wrapper {
    width: 50vw;
  }
  .new-product__input-title {
    font-size: 1.5em;
  }
  .new-product__input {
    width: 90%;
  }
  .new-product-select-width {
    width: 90% !important;
  }
  .ressuply-products__edit-amount-wrapper {
    justify-content: end;
  }
}
@media only screen and (max-width: 500px) {
  .modal-mask {
    font-size: 3vw;
  }
  .new-product__main-container {
    width: 110vw;
  }
}
@import "./new-product.modal";
</style>
